import {
  useTheme,
  Typography,
  Box,
  Button,
  Tooltip,
  Stack,
  Avatar,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";

export const LoginButton = ({
  user,
  navigate,
  handleOpenUserMenu,
  toggleDrawer,
}) => {
  const theme = useTheme();

  return user ? (
    <Tooltip title="Meus pedidos">
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          sx={{
            color: "white",
            border: "none",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
          startIcon={
            <Avatar
              sx={{
                bgcolor: theme.palette.primary.dark,
                width: 32,
                height: 32,
                fontSize: "1rem",
              }}
            >
              {user.firstName.charAt(0).toUpperCase()}
            </Avatar>
          }
        />

        <Box
          sx={{
            display: { md: "none", lg: "flex" },
            flexDirection: "column",
            alignItems: "flex-start",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/my-orders");
            toggleDrawer(false);
          }}
        >
          <Typography variant="body1" sx={{ color: "white" }}>
            Olá, {user.firstName}!
          </Typography>
          <Typography variant="body2" sx={{ color: theme.palette.grey[50] }}>
            MEUS PEDIDOS
          </Typography>
        </Box>
      </Stack>
    </Tooltip>
  ) : (
    <Tooltip title="Open settings">
      <Button
        onClick={() => {
          if (handleOpenUserMenu && typeof handleOpenUserMenu === "function") {
            handleOpenUserMenu();
          }
        }}
        sx={{
          textTransform: "none",
          color: "white",
          borderColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50px",
          backgroundColor: `${theme.palette.primary.main}`,
        }}
        endIcon={<LoginIcon />}
        variant="outlined"
      >
        Login
      </Button>
    </Tooltip>
  );
};
